import { Injectable } from '@angular/core';

import { Detail } from '../../models/detail';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class DetailService {
  /**
   * URL for details controller
   * @type {String}
   */
  private detailsURL = 'details';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Delete detail
   * @param  {Detail}       detail Detail to delete
   * @return {Promise<any>}        Server response with request result
   */
  deleteDetail(detail: Detail): Promise<any> {
    return this.httpClient.delete(`${this.detailsURL}/${detail.id}.json`);
  }

  /**
   * Get details of matter
   * @param  {any}          search_params Search params
   * @return {Promise<any>}               Server response with details
   */
  getDetails(search_params: any): Promise<any> {
    search_params.get_details = true;
    return this.httpClient.get(`${this.detailsURL}.json`, search_params);
  }

  /**
   * Get form options for details form
   * @return {Promise<any>} Server response with form options
   */
  getFormOptions(): Promise<any> {
    return this.httpClient.get(`${this.detailsURL}.json`, { get_form_options: true });
  }

  /**
   * Get detail
   * @param  {any}          id Id of detail
   * @return {Promise<any>}    Server response with detail
   */
  getDetail(id: any): Promise<any> {
    return this.httpClient.get(`${this.detailsURL}/${id}.json`, { get_detail: true });
  }

  /**
   * Save detail
   * @param  {Detail}       detail Detail to save
   * @return {Promise<any>}        Server response with request result
   */
  saveDetail(detail: Detail): Promise<any> {
    if (detail.id) return this.httpClient.put(`${this.detailsURL}/${detail.id}.json`, { detail: detail, save_detail: true });
    else return this.httpClient.post(`${this.detailsURL}.json`, { detail: detail, save_detail: true });
  }

  /**
   * Update position of details
   * @param  {Array<number>} detail_ids Ids of details ordered  by position
   * @return {Promise<any>}             Server response with request result
   */
  updatePosition(detail_ids: Array<number>): Promise<any> {
    return this.httpClient.put(`${this.detailsURL}/update_position.json`, { detail_ids: detail_ids });
  }
}
